import { ACCOUNT_ENDPOINTS } from './endpoints';
import { request } from './http';
import { parseOrThrow, userDetailsSchema } from './schemas';
import type { UserProfileDto } from './schemas';

export const fetchProfile = async (signal: AbortSignal | undefined): Promise<UserProfileDto> => {
  const raw = await request('post', ACCOUNT_ENDPOINTS.USER_DETAILS, { signal });
  return parseOrThrow(userDetailsSchema, raw, 'profile').user;
};
